// extracted by mini-css-extract-plugin
export var addButton = "_ja-0";
export var border = "_ja-8";
export var check = "_ja-h";
export var danger = "_ja-6";
export var dropdownContainer = "_ja-1";
export var editModalBody = "_ja-j";
export var footerContainer = "_ja-i";
export var fullWidth = "_ja-a";
export var hide = "_ja-9";
export var icon = "_ja-3";
export var input = "_ja-7";
export var inputFlex = "_ja-b";
export var inputWrapper = "_ja-c";
export var manualFocus = "_ja-5";
export var optionButton = "_ja-4";
export var pillWrapper = "_ja-e";
export var pointer = "_ja-2";
export var showOverflow = "_ja-f";
export var tagsFlex = "_ja-d";
export var xButton = "_ja-g";